import { render, staticRenderFns } from "./SimulateEarnings.vue?vue&type=template&id=19968911&scoped=true"
import script from "./SimulateEarnings.vue?vue&type=script&lang=js"
export * from "./SimulateEarnings.vue?vue&type=script&lang=js"
import style0 from "./SimulateEarnings.vue?vue&type=style&index=0&id=19968911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19968911",
  null
  
)

export default component.exports